import React from 'react';

import type { SVGProps } from 'react';

export const ChevronDownOutlinedIcon: React.FC<SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.25"
      y="-0.25"
      width="23.5"
      height="23.5"
      rx="11.75"
      transform="matrix(1 0 0 -1 0 23.5)"
      fill="#F0F1F2"
    />
    <rect
      x="0.25"
      y="-0.25"
      width="23.5"
      height="23.5"
      rx="11.75"
      transform="matrix(1 0 0 -1 0 23.5)"
      stroke="#CCCAD7"
      strokeWidth="0.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7353 14.5152C11.8818 14.6616 12.1192 14.6616 12.2657 14.5152L16.7657 10.0152C16.9121 9.86872 16.9121 9.63128 16.7657 9.48484C16.6192 9.33839 16.3818 9.33839 16.2353 9.48484L12.0005 13.7197L7.76565 9.48484C7.61921 9.33839 7.38177 9.33839 7.23532 9.48484C7.08888 9.63128 7.08888 9.86872 7.23532 10.0152L11.7353 14.5152Z"
      fill="#667180"
    />
  </svg>
);
